import { CheckboxGroup, Loading, TextSpan } from "@dgs/core";
import { useField } from "formik";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { TagOptionResource } from "../../types/tag";
import { TagMultiSelectField } from "../../ui/TagSelectField";
import { FilterAccordionBody, FilterAccordionItem, FilterCheckbox } from "./AccordionFilterItemStyles";
import { useEventFilterAccordionItems } from "./EventFilterAccordionItemsProvider";

interface Props {
	name: string;
}

export const AccordionItemTag: FC<Props> = ({ name }) => {
	const { t } = useTranslation();
	const [{ value }, , { setValue }] = useField<TagOptionResource[]>(name);
	const { tags, tagsIsLoading, renderTagsAsCheckboxes } = useEventFilterAccordionItems();

	if (!tags || !tags.length) {
		return null;
	}

	const renderBody = () => {
		if (tagsIsLoading) return <Loading />;
		if (renderTagsAsCheckboxes) {
			return (
				<CheckboxGroup name={name}>
					{tags.map((tag) => (
						<FilterCheckbox
							key={`${tag.id}`}
							name={`tag-${tag.id}`}
							value={value.some((v) => v.id === tag.id)}
							label={tag.name}
							onChange={(e) => setValue(e.target.value ? [...value, tag] : value.filter((v) => v.id !== tag.id))}
						/>
					))}
				</CheckboxGroup>
			);
		}
		return <TagMultiSelectField name={name} label="" />;
	};

	return (
		<FilterAccordionItem
			title={t("Tag")}
			actions={<TextSpan $size="small">{t("IN_RELATION")}</TextSpan>}
			initialOpen={value && value.length > 0}
			body={<FilterAccordionBody>{renderBody()}</FilterAccordionBody>}
		/>
	);
};
